module.exports = __webpack_public_path__ + "static/media/statystyki.736069bb.svg";